var BlogClass = {
    options: {},
    init: function (options) {
        this.options = $.extend({}, this.options, options);
    },

    initLoadMore: function () {
        $(document).on('click', '.kf-blog__btn-load-more', function (e) {
            e.preventDefault();
            let $container = $('.kf-blog__container');
            let $paginateButton = $(e.currentTarget);
            $paginateButton.prop('disabled', true);
            let btnLoadingText = $paginateButton.data('loading-text');
            let btnText = $paginateButton.html();
            Common.buttonLoading($paginateButton, btnLoadingText);
            let url = $paginateButton.data('url');

            function getDataForm() {
                let dataForm = $paginateButton.data('form');
                if (dataForm === undefined) {
                    dataForm = {
                        page: 1
                    };
                }
                if (dataForm.page === undefined) {
                    dataForm.page = 2;
                } else {
                    dataForm.page += 1;
                }
                return dataForm;
            }

            function setDataForm(dataForm) {
                $paginateButton.attr('data-form', JSON.stringify(dataForm));
            }

            let dataForm = getDataForm();
            $.ajax({
                type: 'GET',
                url: url,
                data: dataForm,
                dataType: 'json',
                success: function (resp) {
                    let items = resp.data;
                    let html = '';
                    for (let i = 0; i < items.length; i++) {
                        let item = items[i];
                        html += `<div class="col-md-4">${item.html}</div>`;
                    }
                    let $el = $(html);
                    $container.append($el);

                    if (resp.current_page >= resp.last_page) {
                        $paginateButton.fadeOut();
                    }

                },
                complete: function (data) {
                    Common.lazyload();
                    setDataForm(dataForm);
                    $paginateButton.prop('disabled', false);
                    $paginateButton.attr('data-loading', 0);
                    Common.buttonReset($paginateButton, btnText);
                }
            });

        })
    },

    initActions: function () {

    }
};

$(document).ready(function () {
    BlogClass.init();
    BlogClass.initLoadMore();
    BlogClass.initActions();
});




